<template>
<v-container fluid class="pa-0 ma-0">

<v-layout class="ml-5 mt-5" row>
  <img  height="40px" src="@/assets/logo.svg" alt="">
  <span class="ml-5 mt-5 font-weight-light">PROTEKTOR-POLSKA mail: logistyka@protektor-polska.pl tel: +48 884 077 377</span>
</v-layout>
    <v-layout  column align-center justify-center>
    <v-col cols="12" class="my-6"></v-col>
    <v-col cols="12">
      <v-data-table
        disable-pagination
        fixed-header
        height="600px"
        :headers="headers"
        :items="orders"
        hide-default-footer
        class="elevation-1 visible"
      >
      </v-data-table>
    </v-col>

    <v-col cols="10">
      <v-layout row>
        <v-spacer></v-spacer>
        <v-btn  class="mr-3 nonvisible" dark color="blue darken-1" href="/zamowienia">wróć</v-btn>
        <v-btn
          color="black"
          outlined
          class="mb-2 mr-3 nonvisible"
          @click="windowPrint()"
        >
          <v-icon> mdi-printer </v-icon>
        </v-btn>
      </v-layout>
    </v-col>
  </v-layout>

  </v-container>
</template>

<script>
export default {
  methods: {
    windowPrint: function () {
      window.print();
    },
  },
  mounted() {
    this.orders = JSON.parse(localStorage.getItem("dataToPrint"));
  },
  data() {
    return {
      headers: [
        { text: "Data dodania", value: "createdAtFormated" },
        { text: "ZAS", value: "id_zas" },
        { text: "ZAZ", value: "id_zaz" },
        { text: "Załadunek", value: "loading_place" },
        { text: "Rozładunek", value: "unloading_place" },
        { text: "Waga", value: "weight"},
        { text: "Stawka", value: "planned_transport_cost" },
        { text: "Dostawa", value: "delivery_method"},
        { text: "Status", value: "delivery_status"},
        { text: "Transport", value: "order_type_formated" },
        { text: "Rozliczenie", value: "drivers_settlement" }
      ],
      orders: [],
    };
  },
};
</script>
<style>
@media print {
  .nonvisible {
    display: none;
  }
  body
{
  margin: 1mm 1mm 1mm 1mm;
}
}
</style>